import styled from "styled-components/macro";
import {
  primary_brand,
  secondary_brand,
  hoverSecondarySelect,
  error,
  success,
  errorBg,
  subtle_text,
} from "../../assets/StyledComponent/Variables.Style";

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5%;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  color: rgba(0, 0, 0, 0.75);
  z-index: 6000;
  background-color: white;
  width: 90%;
  height: 15%;
  justify-content: space-between;
  .notification {
    background-color: ${primary_brand};
    display: flex;
    width: 100%;

    color: white;
    padding: 10px;
  }

  .notification-section {
    width: 100%;
    display: flex;
    gap: 10px;
    margin-top: 5px;
    flex-direction: column;
    padding: 10px;
    align-items: center;
  }

  .bellOuter {
    background-color: ${secondary_brand};
    width: 28%;
    height: 81px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4492cf;
    border-radius: 60%;
  }
`;
